import { gql } from '@apollo/client';
import { REGISTRATION_ADDRESS_FRAGMENT, REGISTRATION_INSURANCE_US_FRAGMENT } from 'op-graphql/fragments';

export const REVIEW_AND_SUBMIT_QUERY = gql`
  query ReviewAndSubmit($id: ID!) {
    patient(id: $id) {
      id
      userProfile {
        id
        showHealthAssessment
      }
      ida
      regFormStatus
      healthAssessment {
        id
        status
      }
      firstName
      middleName
      lastName
      patientGender
      dob
      resolvedNamePrefix
      preferredName
      formattedSsn

      primaryPhone
      secondaryPhone
      email
      workPhone
      employer

      guardian
      guardianRelationship
      emergencyContact {
        id
        contactType
        relationship
        firstName
        lastName
        mobilePhoneNumber
        homePhoneNumber
        address {
          id
          line1
          line2
          city
          postcode
          state
          country
        }
      }

      countryOfBirth
      stateOfBirth
      areaLivedMost
      currentStateHowLong
      inThisStateAllYear
      alternateAddress {
        id
        ...Address
      }
      alternateAddressPhone

      address {
        id
        ...Address
      }
      facilityAddress {
        id
        ...Address
      }
      inHospitalHospiceFacility
      facilityName
      facilityContactNumber

      primaryProvider
      referringProvider
      advancedDirective
      powerOfAttorney
      livingWill

      primaryInsurance {
        id
        ...InsuranceUS
      }
      hasSecondaryInsurance
      secondaryInsurance {
        id
        ...InsuranceUS
      }
      receiveVeteransAdminBenefits
      veteransAdminName
      veteransContactNumber
      veteransCity
      veteransStateProvince
      veteransZip

      primaryOccupation
      maritalStatusValue
      spouseWorkingStatus
      spouseName
      spouseDob
      formattedSpouseSsn
      spouseContactNumber
      spouseAlternateAddressBool
      spouseAlternateAddress {
        id
        ...Address
      }
      race
      raceSpecified
      ancestry
      niceLanguageAtHome

      heardAboutUs
      heardAboutUsOther
      internetForResearch
      agreeToSurvey
    }
    user {
      id
      isPso
    }
    profile(id: $id) {
      id
      registrationAccessType
    }
  }
  ${REGISTRATION_ADDRESS_FRAGMENT}
  ${REGISTRATION_INSURANCE_US_FRAGMENT}
`;

export const SUBMIT_FORM = gql`
  mutation PatientSubmitRegistrationUs($id: ID!) {
    patientSubmitRegistrationUs(id: $id) {
      patient {
        id
        regFormStatus
      }
    }
  }
`;

export const SUBMIT_FORM_PSO = gql`
  mutation StaffSubmitRegistrationUs($id: ID!) {
    staffSubmitRegistrationUs(id: $id) {
      patient {
        id
        regFormStatus
      }
    }
  }
`;
